"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSubmitSendBox;

var _react = require("react");

var _useTrackEvent = _interopRequireDefault(require("./useTrackEvent"));

var _useWebChatUIContext2 = _interopRequireDefault(require("./internal/useWebChatUIContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function useSubmitSendBox() {
  var _useWebChatUIContext = (0, _useWebChatUIContext2.default)(),
      submitSendBox = _useWebChatUIContext.submitSendBox;

  var trackEvent = (0, _useTrackEvent.default)();
  return (0, _react.useCallback)(function () {
    // We cannot use spread operator as it broken in Angular.
    var method = (arguments.length <= 0 ? undefined : arguments[0]) || 'keyboard';
    trackEvent('submitSendBox', method);
    return submitSendBox.apply(void 0, arguments);
  }, [submitSendBox, trackEvent]);
}